<template>
  <div class="maintenance-record">
    <div class="header">
      <h3>设备SN: {{ device.sn }}</h3>
      <Button type="primary" @click="addNewRecord">新增维保记录</Button>
    </div>

    <Table border :columns="columns" :data="records" height="450">

      <template slot="startTime" slot-scope="{ row }">
        {{ row.startTime ? formatDate00(row.startTime, 'yyyy-MM-dd') : '-' }}
      </template>

      <!-- 结束时间插槽 -->
      <template slot="endTime" slot-scope="{ row }">
        {{ row.endTime ? formatDate00(row.endTime, 'yyyy-MM-dd') : '-' }}
      </template>


      <template slot-scope="{ row }" slot="maintenanceStatus">
        <Tag :color="row.maintenanceStatus === '1' ? 'success' : 'warning'">
          {{ row.maintenanceStatus === '0' ? '维修中' : '维修完毕'}}
        </Tag>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" size="small" @click="editRecord(row)">查看/编辑</Button>
        <Button type="error" size="small" @click="deleteRecord(row, index)" style="margin-left: 8px">删除</Button>
      </template>
    </Table>

    <!-- 编辑弹窗 -->
    <Modal v-model="showEditModal" title="维保记录详情" width="650">
      <EditMaintenanceRecord
          v-if="showEditModal"
          :record="currentRecord"
          :device="device"
          @save="handleSaveRecord"
          @cancel="showEditModal = false"
      />
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import EditMaintenanceRecord from './EditMaintenanceRecord';
import { post, formatDate } from "@/apis/restUtils";

export default {
  name: 'MaintenanceRecordModal',
  components: { EditMaintenanceRecord },
  props: {
    device: Object
  },
  data() {
    return {
      showEditModal: false,
      currentRecord: null,
      columns: [
        { title: '维修单号', key: 'id', width: 100 },
        { title: '开始时间', slot: 'startTime', width: 150 },
        { title: '结束时间', slot: 'endTime', width: 150 },
        {
          title: '维修状态',
          slot: 'maintenanceStatus',
          width: 120,
          filters: [
            { label: '维修中', value: '0' },
            { label: '维修完毕', value: '1' }
          ],
          filterMultiple: false,
          filterMethod: (value, row) => row.maintenanceStatus.includes(value)
        },
        { title: '维修描述', key: 'description', ellipsis: true },
        { title: '操作', slot: 'action', width: 150, align: 'center' }
      ],
      records: []
    };
  },
  mounted() {
    this.loadRecords();
  },
  methods: {
    loadRecords() {
      // 模拟API请求 - 实际应替换为真实API
      post("/organization/maintenance/getRecords", { machinetoolId: this.device.id }, response => {
        this.records = response.data.entity ;
        console.log("this.records :", this.records);
        //     || [
        //   {
        //     id: 'WB202308001',
        //     startTime: '2023-08-01 10:30',
        //     endTime: '2023-08-01 15:45',
        //     status: '维修完毕',
        //     description: '更换主轴轴承，调整传动系统',
        //     technician: '张工'
        //   },
        //   {
        //     id: 'WB202308002',
        //     startTime: '2023-08-05 09:00',
        //     endTime: '',
        //     status: '维修中',
        //     description: '电路板故障排查',
        //     technician: '李工'
        //   }
        // ];
      });
    },

    addNewRecord() {
      this.currentRecord = {
        //id: 'NEW-' + Date.now(),
        startTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm'),
        endTime: '',
        maintenanceStatus: '0',
        description: '',
        machinetoolId: '',
        // technician: ''
      };
      this.showEditModal = true;
    },

    editRecord(record) {
      this.currentRecord = { ...record };
      this.showEditModal = true;
    },

    deleteRecord(record, index) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除维修单 ${record.id} 吗？`,
        onOk: () => {
          post("/maintenance/deleteRecord", { id: record.id }, () => {
            this.records.splice(index, 1);
            this.$Message.success('删除成功');
          });
        }
      });
    },

    handleSaveRecord(record) {
      if (!record.id) {
        // 新增记录
        console.log('new record: ', record);
        post("/organization/maintenance/newRecord", record, response => {
          console.log("response", response);
        });
        this.records.unshift(record);
      } else {
        // 更新记录
        console.log('modify record: ', record);
        post("/organization/maintenance/modifyRecord", record, response => {
          console.log("response", response);
        });

        const index = this.records.findIndex(r => r.id === record.id);
        if (index !== -1) {
          this.records.splice(index, 1, record);
        }
      }
      this.showEditModal = false;
      this.$Message.success('保存成功');
    },

    formatDate00(date, format){
      return formatDate(date, format);
    }
  }
};
</script>

<style scoped>
.maintenance-record {
  padding: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
}
</style>